export const BYOK_NEW_USER_BILLING_LIMIT_MULTIPLIER = 5;
